<div class="innerBanner">
    <div class="container md">
        <div class="viewerAssign">
            <div class="row">
                <div class="col-12 col-md-6">
                   <div class="">
                       <a href="javascript:void(0);" class="backLink"><b><img src="assets/images/icons/backarrow.png" /></b>BACK  TO COURSE DETAILS</a>
                   </div>
                   <div class="viewerModule">
                       <h2>Introduction to Motor Engine Rerouting</h2>
                       <div class="engineWrap">
                       <div class="joinerDetails mb-0">
                           <span class="joinerDetailsImage">
                               <img src="assets/images/icons/doughnut_chart.svg">
                            </span>
                            <div class="joinerContent">
                                <h3>15%</h3>
                                <div class="ghrapWrap mb-0">
                                    <span style="width: 15%;"></span>
                                </div>
                            </div>
                        </div>
                    </div>

                    </div>
                    <div class="viewerSubModule">
                        <div class="viewerSubTitle">
                            <span>SUB MODULE 2</span>
                            <h2>Beginner level Introduction to Barrel Engine</h2>
                        </div>
                        <div class="viewerModifyi">
                            <ul class="modifyIcons">
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/frame.svg" /></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                     
                </div>
                <div class="col-12 col-md-6">
    
                    <div class="timerWrap countdown">
                        <ul>
                            <li>
                                <div class="timer ">
                                    <span>01</span>
                                    <small>hrs</small>
                                </div>
                            </li>
                            <li>
                                <b>:</b>
                            </li>
                            <li>
                                <div class="timer">
                                    <span>10</span>
                                    <small>min</small>
                                </div>
                            </li>
                            <li>
                                <b>:</b>
                            </li>
                            <li>
                                <div class="timer">
                                    <span>34</span>
                                    <small>sec</small>
                                </div>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

 <div class="dynamicBookWrap">
<div class="container">
    <div class="row">
        <div class="questionWrap">
            <div class="questionListWrap">
                <h2>Question 20 <span>[20 out of 20]</span></h2>
                <h3>What is the Fuel oil tank capacity in WDP1 locomotive in litres?</h3>
                <ul class="ausWrap">
                    <li>
                        <div class="questionUi" (click)="passClick()">
                            <input type="radio" name="question01">
                            <b>A</b>
                            <span>500</span>
                        </div>
                    </li>
                    <li>
                        <div class="questionUi" (click)="failedClick()">
                            <input type="radio" name="question01">
                            <b>B</b>
                            <span>800</span>
                        </div>
                    </li>
                    <li>
                        <div class="questionUi">
                            <input type="radio" name="question01" (click)="moudle_passClick()">
                            <b>C</b>
                            <span>300</span>
                        </div>
                    </li>
                    <li>
                        <div class="questionUi">
                            <input type="radio" name="question01" (click)="moudle_failedClick()">
                            <b>D</b>
                            <span>600</span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>

<div class="pagiMainWrap">
    <div class="container">
        <div class="row">
            <div class="pagiWrap">
                <button class="backButton opacty03 d-none"><img src="assets/images/icons/back-gray-arrow.png" /> Back</button>
                <div class="pagecount"><b>20</b>/<b>20</b></div>
                <button [routerLink]="['/Submodule_Passed']" class="btn btn-primary" *ngIf="passBtn">Submit for Evaluation</button>
                <button [routerLink]="['/contact_admin']" class="btn btn-primary" *ngIf="failedBtn">Submit for Evaluation</button>

                <button [routerLink]="['/module_Passed']" class="btn btn-primary" *ngIf="moudle_passBtn">Submit for Evaluation</button>
                <button [routerLink]="['/module_failed']" class="btn btn-primary" *ngIf="moudle_failedBtn">Submit for Evaluation</button>
                <button class="nextButton d-none">Next <img src="assets/images/icons/next-arrow.png" /></button>

            </div>
        </div>
    </div>
</div>

 </div>
